import { useState, useEffect }  from "react";
import { useSelector } from "react-redux";

const Footer = () => {

    const defaultMsg = "App started. The log is empty.";

    let log = useSelector(store => store.log.items);

    useEffect(() => {
        setMsg([...log].pop()?.message ?? defaultMsg);
        setSignal([...log].pop()?.signal ?? 0);
    }, [ log ]);

    const [ msg, setMsg ] = useState(defaultMsg);
    const [ signal, setSignal ] = useState(0);

    const textColor = {
        '0': 'text-gray-400',
        '1': 'text-green-300',
        '-1': 'text-red-300'
    }

    return <div className={`bg-gray-900 text-center py-4 ${textColor[signal]} ${signal}`}>{ msg }</div>
}

export default Footer;